<template>
    <div class='card-view'>
        <div class='card' v-if="fieldDefs && fieldValues">
            <component ref="dynamicComponent" :is="myComponent"></component>
        </div>
        <template v-if='!front'>
            <div class='card-buttons'>            
                <button class='answer-button cmd-dont-know btn btn-danger' @click='$emit("know", 0)'>
                    <div>{{$t("Don't know")}}</div>
                </button>
                <button class='answer-button cmd-know-perfect btn btn-success' @click='$emit("know", 1)'>{{$t("Know")}}</button>
            </div>
        </template>
        <template v-else>
            <div class='buttons'>            
                <button class='answer-button cmd-show-answer btn btn-secondary' @click='showAnswer'>
                    <div>{{$t("Show answer")}}</div>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
import i18n from '@root/components/i18n';
import textField from './text-field.vue';
import imageField from './image-field.vue';
import audioField from './audio-field.vue';
import vue from 'vue';

let style = null;

export default {
    props: ["cardId", "html", "css", "fieldSets", "front", "fields", "name", "example", "translations"],
    mixins: [i18n],
    emits: ["save-user-field", "show-answer"],
    components: {},
    data() {
        return {
        };
    },
    computed: {
        myComponent() {
            let self = this;
            let html = this.format(this.html);
            //console.log(html);
            try {
                let result = vue.compile(html);
                //console.log(result);
            }catch(e) {
                console.error(e);
                html = `Invalid template: ` + e;
            }
            return {
                data() {
                    return {
                        index: 0,
                    }
                },
                computed: {
                    fieldDefs() {
                        return self.fieldDefs;
                    },
                    fieldValues() {
                        return self.fieldValues;
                    },
                },
                components: {
                    textField, imageField, audioField,
                },
                template: html,
                methods: {
                    myUpdate() {
                        this.index++;
                    },
                    added(e) {
                        self.added(e);
                    },
                    removed(e) {
                        self.removed(e);
                    },
                    saveImage(e) {
                        self.$emit('save-image', e);
                    },                    
                }
            }
        },
        fieldValues() {
            let values = {};
            for(let name of Object.keys(this.fieldDefs)) {
                const field = this.fields?.find(c=>c.name === name);
                values[name] = field ?? {name: name, value: [], def: null};
            }       

            return values;
        },
        fieldDefs() {
            const fieldSets = this.fieldSets;
            const fieldDefs = {};
            for(let i=0;i<fieldSets.length;++i) {
                const fieldSet = fieldSets[i];
                for(let j=0;j<fieldSet.fields.length;++j) {
                    const field = fieldSet.fields[j];
                    fieldDefs[field.name] = field;
                }
            }
            return fieldDefs;
        }
    },
    watch: {
        css() {
            style.innerHTML = this.css;
        },
    },
    beforeMount() {        
    },
    mounted() {
        style = document.createElement("style");
        style.id = 'Card inner style';
        style.type = 'text/css';
        style.innerHTML = this.css;
        document.head.appendChild(style);  
    },
    unmounted() {
        if (style) {
            try {
            document.head.removeChild(style);
            }catch(ignored) {}
        }
    },
    methods: {
        onImageSaved(e) {
            const url = e.url;
            const def = this.fieldDefs[e.context.def.name];
            const values = this.fieldValues[e.context.def.name];
            this.added({def: def, values: values, value: url});
            this.saveUserField(values);
        },
        added(e) {
            if (e.def.multi || e.values.value.length == 0) {
                e.values.value.push(e.value);
            } else {
                e.values.value[0] = e.value;
            }
            console.log("Saved user fields", e.values);
            this.$refs.dynamicComponent.myUpdate();
            this.saveUserField(e.values);
        },
        removed(e) {
            let index = e.values.value.indexOf(e.value);
            if (index >= 0) {
                e.values.value.splice(index, 1);
            }
            this.$refs.dynamicComponent.myUpdate();
            this.saveUserField(e.values);
        },
        saveUserField(values) {
            this.$emit('save-user-field', {
                cardId: this.cardId,
                name: values.name,
                value: values.value,
            });
        },        
        showAnswer() {
            this.$emit('show-answer');
        },
        getFrontButtons() {
            return `
                    <div class='buttons'>
                        <button class='btn'>Show answer</button>
                    </div>            
            `;
        },
        onPlay(audio, button) {
            button.textContent = "Pause";
        },
        onEnded(audio, button) {
            button.textContent = "Play";
        } ,       
        hookAudio() {            
            const audios = this.$el.querySelectorAll("audio");
            console.log("Hook audio", audios);
            for(let i=0;i<audios.length;++i) {
                const audio = audios[i];
                const button = audio.nextElementSibling;
                if (!button.classList.contains("value-audio")) {
                    console.warn("Cannot find control button for audio", audio, button);
                    continue;
                }
                button.onclick = () => {
                    if (audio.paused) {
                        audio.play();
                        this.onPlay(audio, button);
                    } else {
                        audio.pause();
                        this.onEnded(audio, button);
                    }
                }
                audio.onended = () => {
                    this.onEnded(audio, button);
                };
            }                
        },
        escapeHtml(unsafe) {
            return unsafe;
            //return unsafe.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
        },
        format(html) {
            const fields =  (this.fields || []).reduce((map,field)=>{map[field.name] = field; return map;}, {})

            const fieldSets = this.fieldSets;
            const fieldDefs = {};
            for(let i=0;i<fieldSets.length;++i) {
                const fieldSet = fieldSets[i];
                for(let j=0;j<fieldSet.fields.length;++j) {
                    const field = fieldSet.fields[j];
                    fieldDefs[field.name] = field;
                }
            }

            if (!html) {
                if (this.front) {                    
                    const name = fieldSets[0]?.fields[0]?.name ?? "Example card";
                    html = "<div class='front-example'>{{" + name + "}}</div>";
                } else {
                    const name = fieldSets[0]?.fields[1]?.name ?? "Example card";
                    html = "<div class='front-example'>{{" + name + "}}</div>";
                }
            }
            html = html.replaceAll(/{{(.*)}}/g, (all,match) => {
                let fieldName = match.trim();
                let field = fields[fieldName];
                const def = field?.def;
                if (!def) return "<span class='unknown-property' title='Unknown property'>" + fieldName + "</span>";
                if(true) {
                    if (def.type === "Text") {
                        return `<text-field :field='fieldValues["${fieldName}"]' @added='added' @removed='removed' :index='index' />`;
                    } else if (def.type === "Image") {
                        return `<image-field :field='fieldValues["${fieldName}"]' @added='added' @removed='removed' @saveImage='saveImage' :index='index' />`;
                    } else if (def.type === "Audio") {
                        return `<audio-field :field='fieldValues["${fieldName}"]' @added='added' @removed='removed' :index='index' />`;
                    }
                    return '';                    
                } else {
                    let values = (fields[match]?.value || []).map(c=>this.escapeHtml(c));
                    if (this.example === true) {
                        values = this.getExampleValue(def);
                    }   
                    let userClass = def.user ? 'user' : '';
                    
                    const userSnippet = def.user ? (
                        `<button class='btn btn-primary btn-sm' @click='test'>Edit</button>`
                        // def.type === "Text" ? `<input type='text' />` :
                        // def.type === "Image" ? `` :
                        // def.type === "Audio" ? `` : ''
                    ): '';

                    const snippet = values.map(value => {
                        if (def.type === "Text") {
                            return `<span class='value-text ${userClass}'>${value}</span>`;
                        } else if (def.type === "Image") {
                            return `<img class='value-image ${userClass}' src='${value}' >`;
                        } else if (def.type === "Audio") {
                            return `<audio class=' ${userClass}'>
                                        <source src="${value}" />
                                        <p>Your user agent does not support the HTML5 Audio element.</p>
                                    </audio>
                                    <span class='value-audio'>Play</span>
                            `;
                        }
                    }).join("\n") + userSnippet;
                    return snippet;
                }
            });

            html = html.replaceAll(/%%(.*)%%/g, (all,match) => {
                match = match.trim();
                if (this.translations) {
                    return this.translations[match] || match;
                } else {
                    return match;
                }
            });

            this.$nextTick(()=>{
                this.hookAudio();
            });

            return html;
        },
        getExampleValue(field) {
            let values = [];
            if (field.type === "Text") {
                values = ["Example " + field.name, "Another " + field.name];
            } else if (field.type === "Image") {
                values = ["/static/images/logo2.png", "/static/images/logo/48.png"];
            } else if (field.type === "Audio") {
                values = ["/static/sounds/cards/bark.mp3"];
            }
            return field.multi ? values : [values[0]];
        },
    }
}
</script>

<style lang="scss">
    .card {
        flex: 1 1;
        overflow-y: auto;
        overflow-x: hidden;
        text-align: center;
        position: relative;
        align-items: center;
        justify-content: center;
    }

    .card-buttons {
        display: flex;
        flex-direction: row;
    }
    .card-buttons .btn {
        flex: 1 1;
        min-height: 50px;
    }

    .value-audio {
        display: inline-block;
        background: deepskyblue;
        color: white;
        border-radius: 8px;
        padding: 4px 8px;
        margin: 4px;
        cursor: pointer;
    }

    .user {
        &.value-text {
            &:after {
                content: '+';
            }
        }
    }

    .value-audio:hover {
        background: skyblue;
    }
    .unknown-property {
        text-decoration: red wavy underline;
    }
</style>

<style lang="scss" scoped>
@import '@root/responsive';

.card-view {
    //border: solid 1px #ccc;
    box-shadow: 1px 1px 2px #888;
    display: flex;
    flex-direction: column;
}

iframe {
    width: 100%;
    height: 100%;
}

.buttons {
    display: flex;
    flex-direction: row;
    overflow: hidden;
}
.answer-button {
    flex: 1 1;
    min-height: 50px;
    border-radius: 0;
    margin: 0;
    font-size: 14px;
}
.btn {
    outline: solid 10 red;
}

</style>


<i18n>
{
    en: {      
    },
    ru: {
        "Know": "Помню",
        "Don't know": "Не помню",
        "Show answer": "Показать ответ",
    }
}
</i18n>
